import { Map } from 'immutable';

import * as types from './types';

const initialState = Map({
  groups: {},
  loading: false,
});

const appStorageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.APP_STORAGE_FETCH_GROUPS.REQUEST: {
      return state.set('loading', true);
    }
    case types.APP_STORAGE_FETCH_GROUPS.SUCCESS: {
      if (payload?.items) {
        payload.items.sort((groupA, groupB) => (
          groupA.recent.upload_timestamp - groupB.recent.upload_timestamp
        ));

        const groups = {};
        payload.items.forEach((group) => {
          if (!groups[group.recent.kind]) groups[group.recent.kind] = [];
          groups[group.recent.kind].push(group);
        });

        return state.withMutations((newState) => {
          newState
            .set('loading', false)
            .set('groups', groups);
        });
      }
      return state.set('loading', false);
    }
    case types.APP_STORAGE_FETCH_GROUPS.FAILURE: {
      return state.set('loading', false);
    }
    default:
      return state;
  }
};

export default appStorageReducer;
